export default {
	API: 'https://api.goemas.com/frontend/api',
	// API: 'https://goemas-dev-api.guestpro.co.id/frontend/api',
	GMAP_API: 'AIzaSyCiaBhFHhz-bo_E4mledl009nFeRCIJr2I',
	// ============ GOLD CARAT & PRICE==============
	megic_price: 41.66,
	murni_price: 45.416,
	gold: [
		{
			title: '1',
			carat: 1,
			murni: false,
		},
		{
			title: '2',
			carat: 2,
			murni: false,
		},
		{
			title: '3',
			carat: 3,
			murni: false,
		},
		{
			title: '4',
			carat: 4,
			murni: false,
		},
		{
			title: '5',
			carat: 5,
			murni: false,
		},
		{
			title: '6',
			carat: 6,
			murni: false,
		},
		{
			title: '7',
			carat: 7,
			murni: false,
		},
		{
			title: '8',
			carat: 8,
			murni: false,
		},
		{
			title: '9',
			carat: 9,
			murni: false,
		},
		{
			title: '10',
			carat: 10,
			murni: false,
		},
		{
			title: '11',
			carat: 11,
			murni: false,
		},
		{
			title: '12',
			carat: 12,
			murni: false,
		},
		{
			title: '13',
			carat: 13,
			murni: false,
		},
		{
			title: '14',
			carat: 14,
			murni: false,
		},
		{
			title: '15',
			carat: 15,
			murni: false,
		},
		{
			title: '16',
			carat: 16,
			murni: false,
		},
		{
			title: '17',
			carat: 17,
			murni: false,
		},
		{
			title: '18',
			carat: 18,
			murni: false,
		},
		{
			title: '19',
			carat: 19,
			murni: false,
		},
		{
			title: '20',
			carat: 20,
			murni: false,
		},
		{
			title: '21',
			carat: 21,
			murni: false,
		},
		{
			title: '22',
			carat: 22,
			murni: false,
		},
		{
			title: '23',
			carat: 23,
			murni: false,
		},
		{
			title: '24',
			carat: 24,
			murni: false,
		},
		{
			title: '24K LM No Brand (99%)',
			carat: 24,
			murni: false,
		},
		{
			title: '24K LM Antam (99.9%)',
			carat: 24,
			murni: false,
		},
		{
			title: '24K LM UBS (99.99%)',
			carat: 24,
			murni: false,
		},
		{
			title: '24K LM Antam Lama (99.99%)',
			carat: 24,
			murni: false,
		},
		{
			title: '24K LM Antam Baru (99.99%)',
			carat: 24,
			murni: false,
		},
		// {
		// 	title: '24K LM No Brand (99%)',
		// 	carat: 25.20,
		// 	murni: false,
		// },
		// {
		// 	title: '24K LM Antam (99.9%)',
		// 	carat: 25.56,
		// 	murni: false,
		// },
		// {
		// 	title: '24K LM UBS (99.99%)',
		// 	carat: 25.49,
		// 	murni: false,
		// },
		// {
		// 	title: '24K LM Antam Lama (99.99%)',
		// 	carat: 26.09,
		// 	murni: false,
		// },
		// {
		// 	title: '24K LM Antam Baru (99.99%)',
		// 	carat: 26.64,
		// 	murni: false,
		// },
	],


	// ============ SILVER CARAT & PRICE==============
	silver: [
		{
			quality: 925,
		},
		{
			quality: 500,
		}
	]
}


// WEBPACK FOOTER //
// ./src/config/index.js